import React from 'react';
import FieldReadOnly from 'src/components/atoms/field/field-readonly/field-readonly.component';
import Lang from 'src/libraries/language';
import { IRequestCircuit } from 'src/models/request.model';

type IProps = {
  data?: IRequestCircuit[];
};

const FlightRequestCircuit: React.FC<IProps> = ({ data = [] }) => {
  return (
    // In Database Pipeline Number is mapped to circuit
    <FieldReadOnly label={Lang.LBL_PIPELINE_NUMBER}>
      {data.map((item) => item.value).join(', ')}
    </FieldReadOnly>
  );
};

export default FlightRequestCircuit;
